import { dataStoreRouteLoader } from 'datastore/datastore_route_loader';
import FormValuesSerializer from 'serializers/form_values_serializer';
import { FormEvents } from 'form/events/form_event_handler';
import { FlashMessageAPI, FormAPI } from 'lecom-api';
import { ModalActions} from '../../realize_overrides/stores/modal_store';
import SearcherTypes from 'searcher/searcher_types';
import moment from 'moment-timezone';
import { getTimeZone, getFormatDate } from 'utils/timeZone';
import { formatDateToBasic } from 'utils/date_utils_new.js';
import { getApiValueDecimalNumber } from 'utils/formatting_utils';

export const execute = (searcherAction, { filters = {}, page, perPage } = {}) => {
	return new Promise((resolve, reject) => {
		let searcherParams = buildSearcherParams(searcherAction, filters, page, perPage);
		const formAPI = FormAPI.form(searcherAction.formId);
		formAPI.publish(FormEvents.SEARCHER_LOAD);
		formAPI.showLoader({ isScroll: false });

		searcherParams.data.values = searcherParams.data.values.map(paramValue => {
			const field = formAPI.allFields().find(f => f.id === paramValue.id);

			if (paramValue.value !== null && paramValue.value !== undefined && paramValue.value !== "") {
				if (field.type() === 'NUMBER' || field.type() === 'DECIMAL' || field.type() === 'CURRENCY') {
					return {
						...paramValue,
						value: typeof paramValue.value === "string" ? getApiValueDecimalNumber(paramValue.value, field.prefix()) : paramValue.value
					}
				}
			}

			return {
				...paramValue
			}
		});

		if (searcherAction.searcherType === SearcherTypes.REFRESH) {
			const fieldToRefresh = formAPI.allFields().find(f => f.id === searcherAction.formFieldName);

			if (fieldToRefresh.type() === 'TEXT') {
				searcherParams.data.values = searcherParams.data.values.map(paramValue => {
					const fieldFromRefresh = formAPI.allFields().find(f => f.id === paramValue.id);

					if (fieldFromRefresh.type() === 'DATE' && moment.tz(paramValue.value, getFormatDate(paramValue.value), getTimeZone()).utc().isValid()) {
						return {
							...paramValue,
							value: formatDateToBasic(paramValue.value)
						}
					}

					return {
						...paramValue
					}
				});
			}
		}

		dataStoreRouteLoader.load(searcherAction.dataStoreRoute, searcherParams)
			.then(handleLoadSearcherSuccess.bind(this, formAPI, resolve, searcherAction.formFieldName))
			.catch(handleLoadSearcherError.bind(this, formAPI, reject, searcherAction.formFieldName));
	});
};

const buildSearcherParams = (searcherAction, filters, page, perPage) => {
	const serializedFormValues = FormValuesSerializer.serializeBasicFormValues({
		withGridFormValues: true,
		formId: searcherAction.formId,
	}).filter(filterSerialized(searcherAction, filters));

	const filterData = Object.keys(filters).map((filterKey) => {
		return {
			id: filterKey,
			value: (filters[filterKey] || '')
		};
	});

	return {
		data: { values: serializedFormValues.concat(filterData) },
		page,
		size: perPage,
	};
};

const filterSerialized = (searcherAction, filters) => {
	return function(formValue) {
		const { searcherType, mappings } = searcherAction;

		if (searcherType === 'lookup') {
			const inputsFilter = getInputsFilter(mappings);
			return !Object.keys(filters).includes(formValue.id) && !Object.keys(inputsFilter).includes(formValue.id);
		}
		else {
			return !Object.keys(filters).includes(formValue.id);
		}
    }
}

const getInputsFilter = (searcherMappings) => {
	var objSearcher = {};

	searcherMappings.forEach(searcherMapping => {
		if (!!searcherMapping.searchable) {
			let fieldName = searcherMapping.formField.name;
			objSearcher[fieldName] = searcherMapping.formField;
		}
	});

	return objSearcher;
}

const handleLoadSearcherSuccess = (formAPI, resolve, formFieldName, response) => {
	formAPI.allFields().find(f => f.id === formFieldName).publish(FormEvents.SEARCHER_LOAD_SUCCESS, response);

	/*timeout porque a modal tem uma animacao de abertura igual a 700 ms*/
	setTimeout(function(){
		$('.grey lighten-2').css({ overflow: 'auto' });

		setTimeout(() => {
			formAPI.hideLoader({ isScroll: false });
		}, 10);
	}, 1000);

	resolve(response);
};

const handleLoadSearcherError = (formAPI, reject, formFieldName, reason) => {
	formAPI.allFields().find(f => f.id === formFieldName).publish(FormEvents.SEARCHER_LOAD_ERROR, reason);

	/*timeout porque a modal tem uma animacao de abertura igual a 500 ms*/
	setTimeout(function(){
		formAPI.hideLoader({ isScroll: false });
	}, 1000);

	FlashMessageAPI.flash('flash-search-modal').addMessage({
		message: Realize.i18n.t('modal.lupa.warningSelectLupa'),
		type: 'error'
	});

	reject(reason);
};

export default {
	execute
};
